// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var Lunarbox_Control_Monad_Dataflow_Solve_Unify = require("../Lunarbox.Control.Monad.Dataflow.Solve.Unify/index.js");
var Lunarbox_Data_Dataflow_Runtime = require("../Lunarbox.Data.Dataflow.Runtime/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Random_LCG = require("../Random.LCG/index.js");
var Test_QuickCheck = require("../Test.QuickCheck/index.js");
var Test_QuickCheck_Arbitrary = require("../Test.QuickCheck.Arbitrary/index.js");
var Test_QuickCheck_Gen = require("../Test.QuickCheck.Gen/index.js");
var DifferentTypes = (function () {
    function DifferentTypes(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    DifferentTypes.create = function (value0) {
        return function (value1) {
            return new DifferentTypes(value0, value1);
        };
    };
    return DifferentTypes;
})();
var CheckFailures = (function () {
    function CheckFailures(value0) {
        this.value0 = value0;
    };
    CheckFailures.create = function (value0) {
        return new CheckFailures(value0);
    };
    return CheckFailures;
})();
var typeToArbitrary = function (v) {
    if (v instanceof Lunarbox_Data_Dataflow_Type.TConstant) {
        if (Data_Eq.eq(Lunarbox_Data_Dataflow_Type.typeEq)(v)(Lunarbox_Data_Dataflow_Type.typeNumber)) {
            return Data_Functor.map(Test_QuickCheck_Gen.functorGen)(Lunarbox_Data_Dataflow_Runtime["Number"].create)(Test_QuickCheck_Arbitrary.arbitrary(Test_QuickCheck_Arbitrary.arbNumber));
        };
        if (Data_Eq.eq(Lunarbox_Data_Dataflow_Type.typeEq)(v)(Lunarbox_Data_Dataflow_Type.typeString)) {
            return Data_Functor.map(Test_QuickCheck_Gen.functorGen)(Lunarbox_Data_Dataflow_Runtime["String"].create)(Test_QuickCheck_Arbitrary.arbitrary(Test_QuickCheck_Arbitrary.arbString));
        };
        if (Data_Eq.eq(Lunarbox_Data_Dataflow_Type.typeEq)(v)(Lunarbox_Data_Dataflow_Type.typeBool)) {
            return Data_Functor.map(Test_QuickCheck_Gen.functorGen)(Lunarbox_Data_Dataflow_Runtime.Bool.create)(Test_QuickCheck_Arbitrary.arbitrary(Test_QuickCheck_Arbitrary.arbBoolean));
        };
    };
    if (v instanceof Lunarbox_Data_Dataflow_Type.TConstant && (v.value0 === "Array" && v.value1.length === 1)) {
        return Data_Functor.map(Test_QuickCheck_Gen.functorGen)(Lunarbox_Data_Dataflow_Runtime.NArray.create)(Test_QuickCheck_Gen.arrayOf(typeToArbitrary(v["value1"][0])));
    };
    if (v instanceof Lunarbox_Data_Dataflow_Type.TConstant && (v.value0 === "Function" && v.value1.length === 2)) {
        var go = Test_QuickCheck_Gen.repeatable(function (a) {
            return Test_QuickCheck_Arbitrary.coarbitrary(Lunarbox_Data_Dataflow_Runtime.coarbitraryRuntimeValue)(a)(typeToArbitrary(v["value1"][1]));
        });
        return Data_Functor.map(Test_QuickCheck_Gen.functorGen)(Lunarbox_Data_Dataflow_Runtime["Function"].create)(go);
    };
    return Test_QuickCheck_Arbitrary.arbitrary(Lunarbox_Data_Dataflow_Runtime.arbitraryRuntimeValue);
};
var showSolutionError = new Data_Show.Show(function (v) {
    if (v instanceof DifferentTypes) {
        return "Cannot match type " + (Data_Show.show(Lunarbox_Data_Dataflow_Type.typeShow)(v.value1) + (" with type " + Data_Show.show(Lunarbox_Data_Dataflow_Type.typeShow)(v.value0)));
    };
    if (v instanceof CheckFailures) {
        return "[quickcheck failures]";
    };
    throw new Error("Failed pattern match at Lunarbox.Data.ValidateSolution (line 35, column 1 - line 38, column 51): " + [ v.constructor.name ]);
});
var callWithVals = function ($copy_v) {
    return function ($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v instanceof Data_List_Types.Nil) {
                $tco_done = true;
                return new Data_Either.Right(v1);
            };
            if (v instanceof Data_List_Types.Cons && v1 instanceof Lunarbox_Data_Dataflow_Runtime["Function"]) {
                $tco_var_v = v.value1;
                $copy_v1 = v1.value0(v.value0);
                return;
            };
            $tco_done = true;
            return new Data_Either.Left(v1);
        };
        while (!$tco_done) {
            $tco_result = $tco_loop($tco_var_v, $copy_v1);
        };
        return $tco_result;
    };
};
var validateSolution = function (v) {
    if (!Lunarbox_Control_Monad_Dataflow_Solve_Unify.canUnify(v["current"]["type'"])(v["intended"]["type'"])) {
        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Either.Left.create(new DifferentTypes(v["current"]["type'"], v["intended"]["type'"])));
    };
    if (Data_Boolean.otherwise) {
        var ins = Lunarbox_Data_Dataflow_Type.inputs(v["intended"]["type'"]);
        var prop = Control_Bind.bind(Test_QuickCheck_Gen.bindGen)(Data_Traversable["for"](Test_QuickCheck_Gen.applicativeGen)(Data_List_Types.traversableList)(ins)(typeToArbitrary))(function (vals) {
            var intendedVal = callWithVals(vals)(v.intended.value);
            var currentVal = callWithVals(vals)(v.current.value);
            return Control_Applicative.pure(Test_QuickCheck_Gen.applicativeGen)((function () {
                if (currentVal instanceof Data_Either.Right && intendedVal instanceof Data_Either.Right) {
                    if (Data_Eq.eq(Lunarbox_Data_Dataflow_Runtime.eqRuntimeValue)(currentVal.value0)(intendedVal.value0)) {
                        return Test_QuickCheck.Success.value;
                    };
                    if (Data_Boolean.otherwise) {
                        var err = Data_Show.show(Lunarbox_Data_Dataflow_Runtime.showRuntimeValue)(currentVal.value0) + (" =/= " + Data_Show.show(Lunarbox_Data_Dataflow_Runtime.showRuntimeValue)(intendedVal.value0));
                        return new Test_QuickCheck.Failed(err);
                    };
                };
                if (currentVal instanceof Data_Either.Left) {
                    return Test_QuickCheck.Failed.create("Cannot vall non-function value " + Data_Show.show(Lunarbox_Data_Dataflow_Runtime.showRuntimeValue)(currentVal.value0));
                };
                if (intendedVal instanceof Data_Either.Left) {
                    return Test_QuickCheck.Failed.create("Internal error: " + (Data_Show.show(Lunarbox_Data_Dataflow_Runtime.showRuntimeValue)(intendedVal.value0) + " is not a function"));
                };
                throw new Error("Failed pattern match at Lunarbox.Data.ValidateSolution (line 81, column 12 - line 88, column 83): " + [ currentVal.constructor.name, intendedVal.constructor.name ]);
            })());
        });
        var go = function (seed) {
            return Test_QuickCheck.checkResults(Test_QuickCheck["quickCheckPure'"](Test_QuickCheck.testableGen(Test_QuickCheck.testableResult))(seed)(100)(prop));
        };
        return function __do() {
            var result = Data_Functor.map(Effect.functorEffect)(go)(Random_LCG.randomSeed)();
            var $32 = Data_List["null"](result.failures);
            if ($32) {
                return new Data_Either.Right(Data_Unit.unit);
            };
            return Data_Either.Left.create(CheckFailures.create(Data_Functor.map(Data_List_Types.functorList)(function (v1) {
                return v1.message;
            })(result.failures)));
        };
    };
    throw new Error("Failed pattern match at Lunarbox.Data.ValidateSolution (line 56, column 1 - line 56, column 67): " + [ v.constructor.name ]);
};
module.exports = {
    DifferentTypes: DifferentTypes,
    CheckFailures: CheckFailures,
    validateSolution: validateSolution,
    showSolutionError: showSolutionError
};
